import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import * as URI from "urijs";
import Typography from "material-ui/Typography";
import IconButton from "material-ui/IconButton";
import TelDownload from "../../Icons/TelDownload";
import SendLetterDownload from "../../Icons/SendLetterDownload";
import ArrowToolTip from "../../common/ArrowToolTip";
import Button from "../../Parts/Button";
import { OwnerType } from "../../../constants/ComponentTypes";
import { isEnabledUserRole } from "../../../utils/utils";
import { isEnableDownloadCallHistory } from "../../../utils/userOptionUtils";
import Tabs, { Tab } from "material-ui/Tabs";
import moment from "moment";
import { connect } from "react-redux";

const styles = () => ({
  root: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    backgroundColor: "white",
    minHeight: "98px",
  },

  headerContainer: {
    background: "#040E35",
    height: "141px",
    width: "100%",
    color: "#FFFFFF",
    padding: "0px 20px",
    position: "relative",
    boxSizing: "border-box",
  },

  header: {
    height: "73px",
    display: "flex",
    width: "100%",
    alignItems: "center",
    padding: "0px 15px",
    position: "relative",
    boxSizing: "border-box",
  },

  heading: {
    marginBottom: "4px",
    color: "#FFFFFF",
    fontWeight: "bold",
  },

  timestamp: {
    color: "#B1B3B9",
  },

  control: {
    display: "flex",
    alignItems: "center",
    padding: "8px 15px",
  },

  container: {
    width: "100%",
    margin: 0,
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-start",
    backgroundColor: "#040E35",
    height: "68px",
    boxSizing: "border-box",
    padding: "0px 0px 0px 20px",
    position: "relative",
  },

  tabRoot: {
    width: "100px",
    fontSize: 15,
    textTransform: "initial",
    transition: "120ms all linear",
    "&:hover, &[aria-selected=true]": {
      borderBottom: "2px solid #FFFFFF",
      color: "#FFFFFF",
      fontWeight: "bold",
    },
    minWidth: "70px",
    border: "none",
  },

  textColorPrimary: {
    color: "#71737B",
  },

  labelContainer: {
    padding: "10px 22px",
  },

  indicator: {
    background: "none",
  },

  iconButton: {
    width: "42px",
    height: "42px",
  },
});

class DashboardHeader extends React.Component {
  state = {
    open: false,
    curTime: moment(),
  };

  componentDidMount() {
    const interval = 1000;
    this.intervalId = setInterval(() => {
      this.setState({
        curTime: moment(),
      });
    }, interval);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  formatName = () => {
    let name = "";

    if (this.props.user && this.props.user.name !== undefined) {
      name = "、" + this.props.user.name + "さん!";
    } else {
      name = "!";
    }

    return name;
  };

  handleTabChange = (e, value) => {
    this.props.handleOwnerTypeChange(value);
  };

  handleLetterOrderedCsvExport = () => {
    if (
      !isEnabledUserRole(
        this.props.user,
        "executive-list",
        "download-letter-ordered-list"
      ) &&
      !isEnabledUserRole(this.props.user, "house-list", "download-list")
    ) {
      window.confirm(
        `アクセス権限がありません。アカウント管理者にお問い合わせください`
      );
    } else {
      if (
        window.confirm(
          `注文済みキーマンを全件エクスポートします。よろしいですか？`
        )
      ) {
        let query = {};
        query = { is_own: this.props.ownerType };
        let path = "letter_order_addresses/csv";

        let url = URI(process.env.REACT_APP_API_BASE_URL + path);
        url = url.query(query);
        window.open(url);
      }
    }
  };

  handleCallHistoryCsvExport = () => {
    if (!isEnableDownloadCallHistory(this.props.user)) {
      window.confirm(
        `コール履歴のダウンロードはオプションの変更が必要です。詳細は右下のチャットにお問い合わせください。`
      );
    } else {
      if (
        window.confirm(
          `コール履歴を全件エクスポートします。よろしいですか？`
        )
      ) {
        let query = {};
        query = { is_own: this.props.ownerType };
        let path = "timeline_status/download_call_history_csv";

        let url = URI(process.env.REACT_APP_API_BASE_URL + path);
        url = url.query(query);
        window.open(url);
      }
    }
  };

  render() {
    const { classes, user, ownerType } = this.props;

    const isShowTeam =
      !!user && (!!user.ownership_authority_flag || !!user.parent_id);
    const noonHours = 12;
    return (
      <div className={classes.root}>
        <div className={classes.headerContainer}>
          <div className={classes.header}>
            <div className={classes.textContainer}>
              <Typography variant="title" className={classes.heading}>
                {`お疲れ様です${this.formatName()}`}
              </Typography>
              <Typography variant="body1" className={classes.timestamp}>
                {this.state.curTime.format(
                  `YYYY年MM月DD日 ${moment().diff(moment().hour(noonHours)) < 0 ? "午前" : "午後"
                  }HH:mm`
                )}
              </Typography>
            </div>
          </div>

          <div className={classes.container}>
            <Tabs
              value={ownerType}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              classes={{
                root: classes.tabsRoot,
                indicator: classes.indicator,
              }}
            >
              {Object.values(OwnerType).map(
                (item, i) =>
                  (isShowTeam || item.value === OwnerType.OWN.value) && (
                    <Tab
                      classes={{
                        root: classes.tabRoot,
                        textColorPrimary: classes.textColorPrimary,
                        labelContainer: classes.labelContainer,
                      }}
                      label={<div>{item.name}</div>}
                      key={i}
                      value={item.value}
                    ></Tab>
                  )
              )}
            </Tabs>

            <div className="flex"></div>
            <div className={classes.control}>
              <ArrowToolTip text="コール履歴を全件エクスポート">
                <IconButton
                  className={classes.iconButton}
                  onClick={
                    user && user.send_letter_flag
                      ? this.handleCallHistoryCsvExport
                      : this.props.togglePlanDialog
                  }
                >
                  <TelDownload color="#FFFFFF" />
                </IconButton>
              </ArrowToolTip>
              <ArrowToolTip text="注文済みキーマンを全件エクスポート">
                <IconButton
                  className={classes.iconButton}
                  onClick={
                    user && user.send_letter_flag
                      ? this.handleLetterOrderedCsvExport
                      : this.props.togglePlanDialog
                  }
                >
                  <SendLetterDownload color="#FFFFFF" />
                </IconButton>
              </ArrowToolTip>

              <Button
                text="決裁者を探す"
                handleClickButton={() => this.props.goTo("/executive-list")}
                size="medium"
                style={{
                  margin: "0px 0px 0px 10px",
                }}
              ></Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DashboardHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  ownerType: PropTypes.string.isRequired,
  handleOwnerTypeChange: PropTypes.func.isRequired,
  togglePlanDialog: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  user: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
  };
};

export default withStyles(styles)(connect(mapStateToProps)(DashboardHeader));



// WEBPACK FOOTER //
// ./src/components/OrderDashboard/sections/DashboardHeader.jsx